import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Company } from '../../../../../types/companies';
import styles from './styles.module.css';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import classNames from 'classnames';
import TableMenuButton from '../TableMenuButton';
import { CompanyFormDataProviderProps } from '../../EditSideBar';
import PolicyRequired from '../../../../../components/common/PolicyRequired';
import { etcColumnRequiredPolicies } from '../';
import { formatTime } from '../../../../../services/formatTime';
import { FC } from 'react';

type Props = {
  company: Company;
  openEdit: (props: CompanyFormDataProviderProps | null) => void;
  sidebarClose: () => void;
};
const TableRow: FC<Props> = ({ company, openEdit, sidebarClose }) => {
  return (
    <tr className={styles.row}>
      <td className={styles.dataCell}>
        <div className={styles.companyNameText}>{company.companyName}</div>
        <div>
          <FontAwesomeIcon icon={faClock} className={styles.icon} />
          <span className={styles.workTime}>{`${formatTime(
            company.businessHoursStartAt
          )}-${formatTime(company.businessHoursEndAt)}`}</span>
        </div>
      </td>
      <td className={styles.dataCell}>
        <div className={styles.addressText}>
          {company.address3
            ? company.prefecture.name +
              company.address1 +
              company.address2 +
              company.address3
            : company.prefecture.name + company.address1 + company.address2}
        </div>
        <div className={styles.phoneNumberContainer}>
          <FontAwesomeIcon icon={faPhone} className={styles.icon} />
          <span className={styles.phoneNumber}>{company.phoneNumber}</span>
        </div>
      </td>
      <td className={styles.dataCell}>{company.companyType.name}</td>
      <td className={styles.dataCell}>
        <div className={styles.wasteItemsText}>
          {(company.companyWasteItems ?? [])
            .map((i) => i.id + '.' + i.name)
            .join(' ')}
        </div>
      </td>
      <PolicyRequired anyPolicy={etcColumnRequiredPolicies}>
        <td className={classNames(styles.dataCell, styles.ellipsisContainer)}>
          <TableMenuButton
            company={company}
            openEdit={openEdit}
            sidebarClose={sidebarClose}
          />
        </td>
      </PolicyRequired>
    </tr>
  );
};

export default TableRow;
